export default "__VITE_ASSET__CXdTEVE$__"